import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

import { LessonStatus, Teacher } from '@df/interfaces';
import { ActivatedRoute } from '@angular/router';
import { TeacherService } from '@app/teacher/services/teacher.service';
import { AccountService } from '@app/teacher/services/account.service';

@Component({
    selector: 'app-analytics-list-class',
    templateUrl: './analytics-list-class.component.html',
    styleUrls: ['./analytics-list-class.component.scss']
})
export class AnalyticsListClassComponent implements OnInit, OnDestroy {
    public headerName: string = 'Завершенные уроки';
    public classId: number;
    public teacher: Teacher;
    public lesson_completed = LessonStatus.LESSON_COMPLETED;

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
        private accountService: AccountService,
        private route: ActivatedRoute,
        private teacherService: TeacherService
    ) {}

    public ngOnInit(): void {
        this.accountService.$currentTeacher.pipe(takeUntil(this.destroy$)).subscribe((teacher: Teacher) => {
            this.teacher = teacher;
        });

        this.route.parent.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
            this.classId = +params['class_id'];
            this.teacherService.setClassId(this.classId);
        });
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
    }
}
